module.exports = __webpack_public_path__ + "static/Diagram-3-f9157fa2c55042ef9aebe844d9764527.png";